import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehicleComparison } from "../../types/Vehicles";

export const getDossierVehicleComparisons = (
  dossierId: string,
  redbookCodes: string[],
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicle-comparisons", dossierId, redbookCodes],
    queryFn: (): Promise<VehicleComparison[]> => {
      return fetchWithAuth<VehicleComparison[]>(
        "getDossierVehicleComparisons",
        dossierId,
        {
          queryParams: {
            redbookCodes: redbookCodes ? redbookCodes.join(",") : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
